import { cx } from "class-variance-authority";
import type { GroupBase, Props } from "react-select";
import ReactSelect from "react-select";
import { Skeleton } from "../Skeleton/Skeleton";
import { Typography } from "../Typography/Typography";

import * as styles from "./Select.module.scss";

type SelectProps = {
  label?: string;
  containerClassName?: string;
  onEdit?: () => void;
  loading?: boolean;
};

const Select = <
  Option,
  IsMulti extends boolean = false,
  Group extends GroupBase<Option> = GroupBase<Option>,
>({
  label,
  containerClassName,
  id,
  classNames,
  loading = false,
  ...props
}: SelectProps & Props<Option, IsMulti, Group>) => {
  return (
    <div
      className={cx(styles.container, containerClassName)}
      data-testid="select-container"
    >
      {label && (
        <Typography
          component="label"
          className={styles.label}
          skeleton={{ loading }}
          htmlFor={id}
          noSpacing
        >
          {label}
        </Typography>
      )}
      {loading ? (
        <Skeleton />
      ) : (
        <ReactSelect
          {...props}
          id={id}
          unstyled
          classNames={{
            ...classNames,
            control: (state) =>
              cx(
                styles.select,
                { [styles.focused]: state.isFocused },
                classNames?.control?.(state),
              ),
            menu: (state) => cx(styles.menu, classNames?.menu?.(state)),
            option: (state) =>
              cx(styles.option, {
                [styles.selected]: state.isSelected,
                [styles.focused]: state.isFocused,
              }),
            loadingMessage: () => styles.loadingMessage,
          }}
        />
      )}
    </div>
  );
};

Select.displayName = "Select";

export { Select };
